import { LOAD_USER_INFO } from '../actionTypes';

const initialState = {};

const userInfo = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_USER_INFO: {
      return { ...state, ...action.payload };
    }
    default: {
      return state;
    }
  }
};

export default userInfo;



// WEBPACK FOOTER //
// ./src/redux/reducers/userInfo.js